export const windowOpener = (url: string): void => {
  window.open(url, '_blank');
}